import React, { useRef, useState } from "react";

import AsyncSelect from "react-select/async";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";
import DatePickerInput from "../../../controls/DatePickerInput";
import InputWithSearch from "../../../controls/InputWithSearch";
import Button from "../../../ui/Button";
import PrintConfirmationModal from "../PrintConfirmationModal";

export default function NewPackageDetails1(props: any) {
  const {
    employeeOptions,
    errors,
    isEdit,
    onSearchLotNumbers,
    handleInputChange,
    packagedProduct,
    values,
    openPackagingOptions,
    handleSavePackageAndPrint,
    showNumberPad,
    setShowNumberPad,
    showBrands,
    scaleIsOpen,
    setScaleIsOpen,
    showErrorModal,
    printInProgress,
    supervisorOptions,
    onLotNumberSelected,
    setEmptyModelOpen,
  } = props;

  const searchRef = useRef<HTMLInputElement | null>(null);

  const asyncRef = useRef(null);
  const [asyncSelectValue, setAsyncSelectValue] = useState<any>({
    value: -1,
    label: "",
  });

  const loadOptions = async function (input: string) {
    if (input.length > 2) {
      return onSearchLotNumbers(input);
    }
    return [];
  };

  const canPrint = () => {
    if (values.is_free_weight && !(values.packing_size > 0)) {
      showErrorModal("Case weight cannot be 0kg for this product");
      return false;
    }
    return true;
  }; // todo oggy fix

  const tryPrint = (extraPayload: Record<string, unknown> = {}) => {
    if (canPrint()) {
      handleSavePackageAndPrint(extraPayload);
    }
  };

  const getProductionRunProductForConfirm = () => {
    const selected = asyncSelectValue;
    if (selected?.value != null && selected.value !== -1) {
      return {
        plu: selected.plu ?? values.production_run_plu,
        name:
          selected.product_name ??
          selected.name ??
          values.production_run_product_name,
        lot_number: selected.lot_number ?? values.lot_number,
      };
    }

    return {
      plu: values.production_run_plu,
      name: values.production_run_product_name,
      lot_number: values.lot_number,
    };
  };

  const openPrintConfirm = (isSkid = false) => {
    if (!canPrint()) return;
    const n = Number(values.number_of_label_to_print) || 1;
    const cartons = n === 1 ? "carton" : "cartons";
    const message = isSkid
      ? `Do you want to print a skid label for ${n} ${cartons}?`
      : `Do you want to print ${n} ${cartons}?`;
    setEmptyModelOpen({
      open: true,
      childComponent: (
        <PrintConfirmationModal
          message={message}
          productionRunProduct={getProductionRunProductForConfirm()}
          packagingProduct={{
            plu: values.plu,
            name: values.product_name,
          }}
          variant={isSkid ? "skid" : "default"}
          setOpen={setEmptyModelOpen}
          onConfirm={() => tryPrint({ is_create_pallet: isSkid })}
        />
      ),
    });
  };

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-2">
          <AsyncSelect
            cacheOptions
            loadOptions={loadOptions}
            options={[]}
            className="w-full"
            ref={asyncRef}
            onChange={(e: any) => {
              setAsyncSelectValue(e ?? { value: -1, label: "" });
              onLotNumberSelected(e);
            }}
            value={asyncSelectValue}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="supervisor"
            options={supervisorOptions}
            defaultValue={isEdit ? packagedProduct.supervisor : null}
            title={"Supervisor"}
            value={values.supervisor}
            error={errors.supervisor}
          />
        </div>
        <div className="col-span-2">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="employee_1"
            options={employeeOptions}
            value={values.employee_1}
            title={"Employee 1"}
            isMulti={true}
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 1"
            name="packaging_material_1"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_1")}
            ref={searchRef}
            value={values.packaging_material_1}
            labelOn={true}
            type="text"
            error={errors.packaging_material_1}
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 2"
            name="packaging_material_2"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_2")}
            ref={searchRef}
            value={values.packaging_material_2}
            labelOn={true}
            type="text"
          />
        </div>
        <div className="col-span-2">
          <InputWithSearch
            label="Packaging Material 3"
            name="packaging_material_3"
            onChange={handleInputChange}
            actionCall={() => openPackagingOptions("packaging_material_3")}
            ref={searchRef}
            value={values.packaging_material_3}
            labelOn={true}
            type="text"
          />
        </div>
        <div className="col-span-2">
          <DatePickerInput
            label="Packaging date"
            name="packaging_date"
            onChange={handleInputChange}
            value={values.packaging_date ? values.packaging_date : new Date()}
            labelOn={true}
            // minDate={new Date()}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.packaging_date}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Room Temp C&deg;"
            name="room_temperature"
            onChange={handleInputChange}
            onClick={() => {
              setShowNumberPad({
                show: true,
                name: "room_temperature",
                onChange: handleInputChange,
                value: values.room_temperature,
                showNumberPad: showNumberPad,
                setShowNumberPad: setShowNumberPad,
              });
            }}
            value={values.room_temperature}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.room_temperature}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Product Temp C&deg;"
            name="product_temperature"
            onChange={handleInputChange}
            onClick={() => {
              setShowNumberPad({
                show: true,
                name: "product_temperature",
                onChange: handleInputChange,
                value: values.product_temperature,
                showNumberPad: showNumberPad,
                setShowNumberPad: setShowNumberPad,
              });
            }}
            value={values.product_temperature}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.product_temperature}
          />
        </div>
        <div className="col-span-2">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            <Button
              type="button"
              variant="secondary"
              className="h-16 !border-[#2563EB] !bg-[#2563EB] !text-white hover:!border-[#1D4ED8] hover:!bg-[#1D4ED8] hover:!text-white"
              onClick={showBrands}
            >
              Brand
            </Button>
            <Button
              type="button"
              variant="secondary"
              className={
                scaleIsOpen
                  ? "h-16 !border-[#0E7490] !bg-[#0E7490] !text-white hover:!border-[#155E75] hover:!bg-[#155E75] hover:!text-white"
                  : "h-16 !border-[#0891B2] !bg-[#0891B2] !text-white hover:!border-[#0E7490] hover:!bg-[#0E7490] hover:!text-white"
              }
              onClick={() => {
                setScaleIsOpen(!scaleIsOpen);
              }}
            >
              Scale
            </Button>
            <Button
              type="button"
              variant="secondary"
              className="h-16 !border-[#D97706] !bg-[#D97706] !text-white hover:!border-[#B45309] hover:!bg-[#B45309] hover:!text-white"
              onClick={() => openPrintConfirm(true)}
              loading={printInProgress}
            >
              Skid label
            </Button>
            <div className="flex flex-col items-center">
              <Button
                type="button"
                variant="primary"
                fullWidth
                className="h-16"
                onClick={() => openPrintConfirm(false)}
                loading={printInProgress}
              >
                Print
              </Button>
              <div className="mt-1 text-xs text-gray-600">RTE Printer</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
